import { Modal } from 'bootstrap'
/**
	* modalHide
	* Hides the targeted modal
	*
	* @param String id (the id attribute of the modal)
	*
*/
export const modalHide = ( id ) => {
	const modal = document.querySelector(`#${id}`)
	const modalInstance = Modal.getInstance(modal)
	if(modalInstance) modalInstance.hide()
}
/**
	* modalShow
	* Shows the targeted modal
	*
	* @param String id (the id attribute of the modal)
	*
*/
export const modalShow = id => {
  const modal = document.querySelector(`#${id}`)
  const modalInstance = new Modal(modal)
  modalInstance.show()
}

/**
  * modalShowing
  * Checks if the targeted modal is currently open.
  *
  * @param String id - The ID of the modal.
  * @return Boolean - true if the modal is open, false otherwise.
*/
export const modalShowing = id => {
	const modalElement = document.querySelector(`#${id}`);
	const modalInstance = Modal.getInstance(modalElement);
	return modalInstance ? modalInstance._isShown : false;
 }